module.exports = __webpack_public_path__ + "static/media/stevers-bakery-logo-1.228e0b9c.svg";